module.exports = __webpack_public_path__ + "static/media/header_error.24f1671b.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Section/header_error.gif
 ** module id = 176
 ** module chunks = 0
 **/